class Carousel {
    constructor(el) {
        this.rootNode =
            typeof el == "string" ? document.getElementById(el) : el;
        this.trackNode = this.rootNode.querySelector(".slides-track");
        this.slidesNodes = Array.prototype.slice.call(
            this.rootNode.querySelectorAll(".slide")
        );
        window.test = this.slidesNodes;
        this.thumbnailsRootNode = this.rootNode.querySelector(
            ".carousel-thumbnails"
        );
        this.progressRootNode = this.rootNode.querySelector(
            ".carousel-progress"
        );
        this.prevNode = this.rootNode.querySelector(".prev-slide");
        this.nextNode = this.rootNode.querySelector(".next-slide");
        this.currentSlide = 0;
        this.intervalTime = 15000;
        this.isTransitionActive = false;

        this.initializeCarousel();
    }

    initializeCarousel() {
        if (!this.slidesNodes.length) {
            return;
        }
        this.addSideSlides();
        this.calculateStyles();
        this.renderThumbnails();
        this.attachEvents();
        this.calculateProgress();
    }

    attachEvents() {
        window.addEventListener("resize", this.calculateStyles.bind(this));
        window.addEventListener("load", this.calculateStyles.bind(this));

        this.loopInterval = new Timer(() => {
            const index = this.currentSlide + 1;
            !this.isTransitionActive && this.goToSlide(index);
        }, this.intervalTime);

        //Need to listen on window, otherwise unfocused tab will fuck things up
        window.addEventListener("transitionend", e => {
            this.isTransitionActive = false;
            if (e.target != this.trackNode) {
                return;
            }
            if (this.slidesNodes[this.currentSlide + 1].childNodes.length) {
                this.slidesNodes[
                    this.currentSlide + 1
                ].firstElementChild.style.opacity = 1;
            }
            this.trackNode.style.transition = "";
            if (this.currentSlide == this.slidesNodes.length - 2) {
                this.currentSlide = 0;
                this.goToSlide(this.currentSlide, true);
            } else if (this.currentSlide == -1) {
                this.currentSlide = this.slidesNodes.length - 3;
                this.goToSlide(this.currentSlide, true);
            }
        });

        new SwipeDetect(this.rootNode, swipeDir => {
            if (swipeDir === "left") {
                let index = this.currentSlide + 1;
                if (!this.isTransitionActive) {
                    this.loopInterval.reset(this.intervalTime);
                    this.goToSlide(index);
                }
            } else if (swipeDir === "right") {
                let index = this.currentSlide - 1;
                if (!this.isTransitionActive) {
                    this.loopInterval.reset(this.intervalTime);
                    this.goToSlide(index);
                }
            }
        });

        if (this.prevNode) {
            this.prevNode.addEventListener("click", e => {
                let index = this.currentSlide - 1;
                if (!this.isTransitionActive) {
                    this.loopInterval.reset(this.intervalTime);
                    this.goToSlide(index);
                }
            });
        }

        if (this.nextNode) {
            this.nextNode.addEventListener("click", e => {
                let index = this.currentSlide + 1;
                if (!this.isTransitionActive) {
                    this.loopInterval.reset(this.intervalTime);
                    this.goToSlide(index);
                }
            });
        }

        window.addEventListener(
            "orientationchange",
            e => {
                this.calculateStyles();
                this.goToSlide(this.currentSlide, true);
            },
            false
        );

        window.addEventListener(
            "resize",
            e => {
                this.calculateStyles();
                this.goToSlide(this.currentSlide, true);
            },
            false
        );
    }

    calculateStyles() {
        this.rootNode.style.width = "";
        this.slideWidth = this.slidesNodes[0].offsetWidth;
        this.rootNode.style.width = this.slideWidth + "px";
        this.trackWidth = this.slideWidth * this.slidesNodes.length;
        this.trackNode.style.transform = `translate3d(-${this.slideWidth *
            (this.currentSlide + 1)}px, 0, 0)`;
        this.trackNode.style.width = `${this.trackWidth}px`;

        //move this to intial state function or something
        if (this.slidesNodes[1].childNodes.length) {
            this.slidesNodes[1].firstElementChild.style.opacity = 1;
        }
    }

    goToSlide(index, noAnimation = false) {
        if (noAnimation) {
            this.trackNode.style.transform = `translate3d(-${this.slideWidth *
                (index + 1)}px, 0, 0)`;
            if (this.slidesNodes[this.currentSlide + 1].childNodes.length) {
                this.slidesNodes[
                    this.currentSlide + 1
                ].firstElementChild.style.opacity = 1;
            }
            return;
        }

        this.toggleActiveClasses(index);

        this.isTransitionActive = true;
        this.trackNode.style.transition = "transform 1s ease";
        window.requestAnimationFrame(() => {
            this.trackNode.style.transform = `translate3d(-${this.slideWidth *
                (index + 1)}px, 0, 0)`;
        });
        this.currentSlide = index;
        this.calculateProgress();
    }

    toggleActiveClasses(index) {
        if (index == this.slidesNodes.length - 2) {
            index = 0;
        } else if (index == -1) {
            index = this.slidesNodes.length - 3;
        }
        this.resetActiveForAll();
        this.slidesNodes[index].classList.add("__active");
        this.thumbnailNodes[index].classList.add("__active");
    }

    addSideSlides() {
        const lastSlideCopy = this.slidesNodes[
            this.slidesNodes.length - 1
        ].cloneNode(true);
        const firstSlideCopy = this.slidesNodes[0].cloneNode(true);
        lastSlideCopy.dataset.index = -1;
        firstSlideCopy.dataset.index = this.slidesNodes.length;
        this.trackNode.insertBefore(lastSlideCopy, this.trackNode.firstChild);
        this.trackNode.appendChild(firstSlideCopy);
        this.slidesNodes = Array.prototype.slice.call(
            this.rootNode.querySelectorAll(".slide")
        );
    }

    renderThumbnails() {
        var carousel = this;
        $('.thumbnail').each(function(i, obj)  {
            obj.addEventListener("click", e => {
                const index = e.target.dataset.index;
                if (this.currentSlide == index) {
                    return;
                }
                carousel.loopInterval.reset(this.intervalTime);
                carousel.goToSlide(parseInt(index));
            });
        });
        this.thumbnailNodes = Array.prototype.slice.call(
            this.thumbnailsRootNode.querySelectorAll(".thumbnail")
        );
    }

    resetActiveForAll() {
        this.slidesNodes.forEach(el => {
            el.classList.remove("__active");
            if (el.childNodes.length) {
                el.firstElementChild.style.opacity = 0;
            }
        });
        this.thumbnailNodes.forEach(el => {
            el.classList.remove("__active");
        });
    }

    calculateProgress() {
        let totalSlides = this.slidesNodes.length - 2;
        let currentSlide = this.currentSlide + 1;
        if (currentSlide > totalSlides) {
            currentSlide = 1;
        }
        let progress = (currentSlide * 100) / totalSlides;
        this.progressRootNode.style.width = progress + "%";
    }
}

class Timer {
    constructor(callback, interval) {
        this.callback = callback;
        this.interval = interval;

        this.timer = this.createTimer(this.callback, this.interval);
    }

    createTimer(cb, t) {
        return setInterval(cb, t);
    }

    stop() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        return this;
    }

    start() {
        if (!this.timerObj) {
            this.stop();
            this.timer = this.createTimer(this.callback, this.interval);
        }
        return this;
    }

    reset() {
        return this.stop().start();
    }
}

class SwipeDetect {
    constructor(el, callback) {
        this.touchElement = el;
        this.callback = callback || function() {};

        this.treshold = 100;
        this.restraint = 100;
        this.allowedTime = 300;

        this.attachEvents();
    }

    attachEvents() {
        this.touchElement.addEventListener(
            "touchstart",
            this.onTouchStart.bind(this),
            false
        );
        this.touchElement.addEventListener(
            "touchend",
            this.onTouchEnd.bind(this),
            false
        );
    }

    onTouchStart(e) {
        let touchObj = e.changedTouches[0];
        this.swipeDir = "none";
        this.startX = touchObj.pageX;
        this.startY = touchObj.pageY;
        this.startTime = new Date().getTime();
    }

    onTouchEnd(e) {
        let touchObj = e.changedTouches[0];
        let distX = touchObj.pageX - this.startX;
        let distY = touchObj.pageY - this.startY;
        let elapsedTime = new Date().getTime() - this.startTime;
        if (elapsedTime <= this.allowedTime) {
            if (
                Math.abs(distX) >= this.treshold &&
                Math.abs(distY) <= this.restraint
            ) {
                this.swipeDir = distX < 0 ? "left" : "right";
            }
        }
        this.callback(this.swipeDir);
    }
}

export default Carousel;
